import axios from './mayiRequest'

export function fetchHouse(ids, aIds, defaultBetweenDays = 1, pagesize = 0, promotion, needNoRepositoty) {
  return axios.post('/feapi/mayipromotionweb/mayibingo/h5/promotion/search/searchhousebyhouseidlist', {
    houseIdList: ids,
    activityIds: aIds,
    needUnactive: false,
    noNeedPrice: false,
    pageSize: +pagesize,
    defaultBetweenDays: +defaultBetweenDays,
    promotion: promotion,
    needNoRepositoty
  })
}

export function fetchHouseV3(ids, aIds, defaultBetweenDays = 1, pagesize = 0, promotion, needNoRepositoty, houseCardType, checkInDate, checkOutDate) {
  return axios.post('/feapi/mayipromotionweb/mayibingo/h5/promotion/search/searchhousebyhouseidlist/v3', {
    houseIdList: ids,
    activityIds: aIds,
    needUnactive: false,
    noNeedPrice: false,
    pageSize: +pagesize,
    defaultBetweenDays: +defaultBetweenDays,
    promotion: promotion,
    needNoRepositoty,
    houseCardType,
    checkInDate,
    checkOutDate
  })
}

export function fetchFavirote(ids) {
  return axios.post('/feapi/mayipromotionweb/mayibingo/h5/favorite/checkfavorite', {
    houseIdList: ids
  })
}

export function doFavirote(id, like) {
  let url = ''
  if (like) {
    url = '/feapi/mayipromotionweb/mayibingo/h5/favorite/deletefavorite'
  } else {
    url = '/feapi/mayipromotionweb/mayibingo/h5/favorite/addfavorite'
  }
  return axios.post(url, {
    houseId: id
  })
}
